// src/services/opcoesPermissoesApi.js
import { db } from "../config/firebase";
import {
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";

export async function apiGetPermissoesGrupo({ grupoId }) {
  if (!grupoId) throw new Error("grupoId não informado");
  const ref = doc(db, "grupos", grupoId, "config", "permissoes");
  const snap = await getDoc(ref);
  const exists = snap.exists();
  if (!exists) {
    return { overrides: {}, version: 2, exists: false };
  }
  const data = snap.data() || {};
  return {
    overrides: data.overrides || {},
    version: data.version || 2,
    exists: true,
    updatedAt: data.updatedAt || null,
    updatedBy: data.updatedBy || null,
  };
}

// Cria o documento do grupo (se não existir), para habilitar edição via UI.
// Observação: o sistema sempre usa PERMISSOES_DEFAULT do código como base;
// aqui gravamos somente overrides/metadados.
export async function apiInitPermissoesGrupo({ grupoId, createdBy }) {
  if (!grupoId) throw new Error("grupoId não informado");
  const ref = doc(db, "grupos", grupoId, "config", "permissoes");
  const snap = await getDoc(ref);
  if (snap.exists()) {
    return { exists: true };
  }
  const payload = {
    version: 2,
    overrides: {},
    createdAt: serverTimestamp(),
    createdBy: createdBy || null,
    updatedAt: serverTimestamp(),
    updatedBy: createdBy || null,
  };
  await setDoc(ref, payload, { merge: true });
  return { exists: true };
}

export async function apiSavePermissoesGrupo({ grupoId, overrides, updatedBy }) {
  if (!grupoId) throw new Error("grupoId não informado");
  const ref = doc(db, "grupos", grupoId, "config", "permissoes");
  const payload = {
    version: 2,
    overrides: overrides || {},
    updatedAt: serverTimestamp(),
    updatedBy: updatedBy || null,
  };
  await setDoc(ref, payload, { merge: true });
  return payload;
}

export async function apiResetPermissoesGrupo({ grupoId }) {
  if (!grupoId) throw new Error("grupoId não informado");
  const ref = doc(db, "grupos", grupoId, "config", "permissoes");
  await deleteDoc(ref);
  return true;
}
